import { render, staticRenderFns } from "./arpaymkoranfrm.vue?vue&type=template&id=68bdbe40"
import script from "./arpaymkoranfrm.vue?vue&type=script&lang=js"
export * from "./arpaymkoranfrm.vue?vue&type=script&lang=js"
import style0 from "./arpaymkoranfrm.vue?vue&type=style&index=0&id=68bdbe40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports